module.exports = __webpack_public_path__ + "static/media/tab5.4a486fd5.svg";